import { useVenue } from '@modules/venue/data'
import { getId } from '@utils/strings'
import { InventoryItem, Venue, VenueEvent } from 'types/model'
import { useEvent } from '@modules/event/data'
import { EventDetailsView } from '../views/event-details-view'
import {
  VenueLayout,
  VenueLayoutSection,
  VenueLayoutTable,
} from 'types/model/venue-layout'

export function EventDetails({
  venue: _venue,
  event: _event,
  tickets,
  packages,
  layouts,
  sections,
  tables,
  embeddedWidget = false,
  inventoryCalendarMinDate,
  inventoryCalendarMaxDate,
  eventPassed: eventPassedSsr,
}: {
  venue: Venue
  event: VenueEvent
  tickets: InventoryItem[]
  packages: InventoryItem[]
  layouts: VenueLayout[]
  sections: VenueLayoutSection[]
  tables: VenueLayoutTable[]
  embeddedWidget?: boolean
  inventoryCalendarMinDate?: number
  inventoryCalendarMaxDate?: number
  /** When set (e.g. widget SSR), avoids hydration mismatch vs client Date.now(). */
  eventPassed?: boolean
}) {
  const { venue, event } = useEventDetailsController({
    venue: _venue,
    event: _event,
  })
  return (
    <EventDetailsView
      event={event.data ?? _event}
      venue={venue.data ?? _venue}
      tickets={tickets}
      packages={packages}
      layouts={layouts}
      sections={sections}
      tables={tables}
      embeddedWidget={embeddedWidget}
      inventoryCalendarMinDate={inventoryCalendarMinDate}
      inventoryCalendarMaxDate={inventoryCalendarMaxDate}
      eventPassedSsr={eventPassedSsr}
    />
  )
}

export function useEventDetailsController({
  venue: _venue,
  event: _event,
}: {
  venue: Venue
  event: VenueEvent
}) {
  const venueId = getId(_venue)
  const eventId = getId(_event)

  const venue = useVenue(venueId, { config: { fallbackData: _venue } })
  const event = useEvent(eventId, { config: { fallbackData: _event } })

  return { event, venue }
}
